module.exports = __webpack_public_path__ + "img/xinxikeji.07095ef2.png";